export enum KeyName {
    Enter = 'Enter',
    Escape = 'Escape',
}
